import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";

import { useQuery } from "react-query";

export function useHVSubstationsByCustomer(customerId?: number) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["hvSubstationsByCustomer", customerId],
    queryFn: async () => {
      if (customerId) return await apiContext.assetApis.getHVSubstationsByCustomer(customerId);
    },
  });
}
